import { render, staticRenderFns } from "./repair-list.vue?vue&type=template&id=5d2ecdb8&scoped=true"
import script from "./repair-list.vue?vue&type=script&lang=js"
export * from "./repair-list.vue?vue&type=script&lang=js"
import style0 from "./repair-list.vue?vue&type=style&index=0&id=5d2ecdb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ecdb8",
  null
  
)

export default component.exports